import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AgreementServicesGridComponent } from './components/agreement/agreement-services-grid.component';
import { ApiVersionComponent } from './components/api-version/api-version.component';
import { InlineProfileComponent } from './components/app/app.profile.component';
import { BoardingCheckListComponent } from './components/boarding-check-list/boarding-check-list.component';
import { CardMenuComponent } from './components/create-movement-job/card-menu.component';
import { DisplayRouteComponent } from './components/create-movement-job/display-route.component';
import { JobDetailsComponent } from './components/create-movement-job/job-details.component';
import { SelectSupplierComponent } from './components/create-movement-job/select-supplier.component';
import { CustomerTaggingComponent } from './components/customer/customer-tagging.component';
import { NewDisputeComponent } from './components/dispute/new-dispute.component';
import { EditTaskComponent } from './components/edit-task/edit-task.component';
import { TaskControl } from './components/job-control/task-control.component';
import { DriverPlanComponent } from './components/job-deployment/driver-plan.component';
import { JobDeploymentDetailsComponent } from './components/job-deployment/job-deployment-details.component';
import { SupplierCardComponent } from './components/job-deployment/supplier-card.component';
import { HistoryTimelineComponent } from './components/job-deployment/timeline.component';
import { IncidentsGridComponent } from './components/job-incidents/incidents-grid.component';
import { IncidentsStacisticsItemComponent } from './components/job-incidents/incidents-statistics-item.component';
import { IncidentsStatisticsComponent } from './components/job-incidents/incidents-statistics.component';
import { CustomerJobsGridComponent } from './components/jobs-inbox/customer-jobs-grid.component';
import { JobsTasksGridComponent } from './components/jobs-inbox/jobs-tasks-grid.component';
import { JobsTasksLiveComponent } from './components/jobs-inbox/jobs-tasks-live.component';
import { VMEJobsFacetedFilteringComponent } from './components/jobs-inbox/vme-jobs-faceted-filtering.component';
import { VmeJobsGridComponent } from './components/jobs-inbox/vme-jobs-grid.component';
import { VmeJobsTasksComponent } from './components/jobs-inbox/vme-jobs-tasks.component';
import { VmeJobsWaitingApprovalComponent } from './components/jobs-inbox/vme-jobs-waiting-approval.component';
import { CustomersInvoicesGridComponent } from './components/manage-invoices/customers-invoices-grid.component';
import { SupplierAdhocInvoiceComponent } from './components/manage-invoices/supplier-adhoc-invoice.component';
import { SupplierInvoiceViewComponent } from './components/manage-invoices/supplier-invoice-view.component';
import { SuppliersBatchesComponent } from './components/manage-invoices/suppliers-batches.component';
import { SuppliersInvoicesGridComponent } from './components/manage-invoices/suppliers-invoices-grid.component';
import { TransactionLinesGridComponent } from './components/manage-invoices/transaction-lines-grid.component';
import { OrgStructureComponent } from './components/manage-org-structure/manage-org-structure.component';
import { OrgStructureMainComponent } from './components/manage-org-structure/org-structure-main.component';
import { ManagePostcodesWeightComponent } from './components/manage-postcodes-weight/manage-postcodes-weight.component';
import { ManagePremiumsComponent } from './components/manage-postcodes-weight/manage-premiums.component';
import { ContextMenuMapDirective } from './components/map-control/context-menu-map.directive';
import { DirectionsMapDirective } from './components/map-control/directions-map.directive';
import { MapControl } from './components/map-control/map-control.component';
import { OrderCompletedComponent } from './components/order-uploads/order-completed.component';
import { OrderValidateComponent } from './components/order-uploads/order-validate.component';
import { OrganisationSelectListComponent } from './components/organisation-list/organisation-select-list.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { RoutesRolesComponent } from './components/routes-roles/routes-roles.component';
import { StepIndicatorComponent } from './components/step-indicator/step-indicator.component';
import { SupplierAvailabilityCalendarComponent } from './components/supplier-availability-calendar/supplier-availability-calendar.component';
import { SupplierAvailabilityComponent } from './components/supplier-availability/supplier-availability.component';
import { XeroSettingsComponent } from './components/xero-settings/xero-settings.component';
import { NewSupplierFeedbackComponent } from './components/supplier-feedback/new-supplier-feedback.component';
import { TaggingRequirementsDetailsComponent } from './components/tagging-requirements-details/tagging-requirements-details.component';
import { TaggingSelectCustomerComponent } from './components/tagging-select-customer/tagging-select-customer.component';
import { TaggingSelectSupplierComponent } from './components/tagging-select-supplier/tagging-select-supplier.component';
import { TaggingTagsDetailsComponent } from './components/tagging-tags-details/tagging-tags-details.component';
import { UserDetailsComponent } from './components/users/common-users/user-details.component';
import { OrgTreeComponent } from './components/users/org-tree.component';
import { AppFullCalendarComponent } from './modules/driver-experience/app-full-calendar/app-full-calendar.component';
import { AppWeeklyCalendarComponent } from './modules/driver-experience/app-weekly-calendar/app-weekly-calendar.component';
import { SupplierJobsCardComponent } from './modules/driver-experience/job-list/supplier-jobs-card.component';
import { SupplierJobsGridComponent } from './modules/driver-experience/job-list/supplier-jobs-grid.component';
import { DatetimePickerComponent } from './user-controls/datetime-picker.component';
import { VmeCommonModule } from './vme-common.module';
import { VmeDirectivesModule } from './vme-directives.module';
import { VmePipesModule } from './vme-pipes.module';
import { ECMatchDetailsComponent } from './components/ec-matches/ec-match-details.component';
import { ECMatchJobDetailsComponent } from './components/ec-matches/ec-match-job-details.component';
import { DashboardEngineiusKPIComponent } from './components/dashboard/KPIs/dashboard-engineius-kpi.component';
import { DashboardEngineiusKPIsTopLevelComponent } from './components/dashboard/KPIs/dashboard-engineius-kpis-toplevel.component';
import { DashboardEngineiusKPICommercialComponent } from './components/dashboard/KPIs/dashboard-engineius-kpis-commercial.component';
import { DashboardEngineiusKPIOperationsComponent } from './components/dashboard/KPIs/dashboard-engineius-kpis-operations.component';
import { DashboardEngineiusKPIGeneralComponent } from './components/dashboard/KPIs/dashboard-engineius-kpi-general.component';
import { DashboardEngineiusKPIFinancialComponent } from './components/dashboard/KPIs/dashboard-engineius-kpis-financial.component';

import { JobTimeWindowComponent } from './components/create-movement-job/job-time-window.component';
import { ManageTimeBandPremiumsComponent } from './components/manage-timeband-premiums/manage-timeband-premiums.component';

import { DashboardCustomerKPIVolumeComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-volume.component';
import { DashboardCustomerKPITopLevelComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-toplevel.component';
import { DashboardCustomerKPIServiceLevelsComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-servicelevels.component';
import { DashboardCustomerKPIUrgencyComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-urgency.component';
import { DashboardCustomerKPITimeWindowsComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-timewindows.component';
import { DashboardCustomerKPIDisplayComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-display.component';
import { DashboardCustomerKPISummaryComponent } from './components/dashboard/CustomerKPIs/dashboard-customer-kpi-summary.component';

import { FacetedFilteringSavedSearchesComponent } from './components/jobs-inbox/faceted-filtering-saved-searches.component';
import { JobAlertSettingsAdminModule } from './components/job-alert-settings/job-alert-settings-admin.module';
import { ChecklistCategoryItemModule } from './components/checklist-category-item/checklist-category-item.module';
import { KeyMetricComponent } from './components/dashboard/KeyMetrics/key-metric.component';
import { TableModule } from 'primeng/table';
import { OrganisationSelectorGridComponent } from './components/organisation-selector-grid/organisation-selector-grid.component';
import { RescheduleTaskComponent } from './components/reschedule-task/reschedule-task.component';
import { RescheduleTaskDialogComponent } from './components/reschedule-task/reschedule-task-dialog.component';
import { ToastModule, VirtualScrollerModule } from 'primeng';
import { AllocateJobDialogComponent } from './components/job-deployment/allocate-job-dialog.component';
import { AcceptJobDialogComponent } from './modules/driver-experience/job-list/accept-job-dialog.component';
import { TaskSupplierScheduleStepComponent } from './components/task-supplier-schedule/task-supplier-schedule-step.component';
import { EditTaskScheduleDialogComponent } from './components/job-control/edit-task-schedule-dialog.component';
import { AllocateDriverDialogComponent } from './modules/driver-experience/job-list/allocate-driver-dialog.component';
import { SupplierScheduleDialogComponent } from './components/task-supplier-schedule/supplier-schedule-dialog.component';
import { DisplayRouteSimpleComponent } from './components/create-movement-job/display-route-simple.component';
import { TaskSupplierScheduleTimelineComponent } from './components/task-supplier-schedule/task-supplier-schedule-timeline.component';
import { SupplierSignupTypeComponent } from './components/supplier-signup-type/supplier-signup-type.component';
import { ViewOdometerImageDialogComponent } from './components/job-control/view-odometer-image-dialog.component';
import { TaskSupplierSchedulePanelComponent } from './components/task-supplier-schedule/task-supplier-schedule-panel.component';
import { TaskSupplierScheduleWindowComponent } from './components/task-supplier-schedule/task-supplier-schedule-window.component';
import { VehicleAddressComponent } from './components/common/vehicle-address.component';
import { OrderLimitsCalendarComponent } from './components/customer-order-limits/order-limits-calendar/order-limits-calendar.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RouteHideReasonDialogComponent } from './modules/driver-experience/job-list/route-hide-reason-dialog.component';
import { AgmOverlays } from 'agm-overlays';
import { CustomerSitesComponent } from './components/customer-sites/customer-sites.component';
import { CustomerSitesOpeningTimesComponent } from './components/customer-sites/customer-sites-opening-times.component';
import { CustomerSitesOpeningTimesRowComponent } from './components/customer-sites/customer-sites-opening-times-row.component';
import { JobScreenGalleryComponent } from './components/job-control/job-screen-gallery.component';
import { BankHolidayWarningComponent } from './components/create-movement-job/bank-holiday-warning/bank-holiday-warning.component';
import { TaskPolylineMapDirective } from './components/map-control/task-polyline-map.directive';
import { CreateMovementDepartmentTeamComponent } from './components/create-movement-job/create-movement-department-team/create-movement-department-team.component';
import { SupplierJobsInboxItemComponent } from './modules/driver-experience/job-list/supplier-jobs-inbox-item.component';
import { TasksMapComponent } from './modules/driver-experience/job-list/tasks-map.component';
import { MobileInformationsComponent } from './components/mobile-informations/mobile-informations.component';
import { AlgoTravelPreferencesModule } from './components/algo-travel-preferences/algo-travel-preferences.module';
import { OverlayPanelInputComponent } from './user-controls/overlay-panel-input/overlay-panel-input.component';
import { TaskStaticMapComponent } from './components/map-control/task-static-map.component';
import { CustomerSitesEditorComponent } from './components/customer-sites/customer-sites-editor.component';
import { AvailabilityHelpComponent } from './modules/driver-experience/availability-help/availability-help.component';
import { TaskTimeAndLocationContainerComponent } from './modules/driver-experience/job-list/task-time-and-location-container.component';
import { TaskDividerComponent } from './modules/driver-experience/job-list/task-divider.component';
import { HideJobDialogComponent } from './modules/driver-experience/job-list/hide-job-dialog.component';
import { AllocateDepotDialogComponent } from './modules/driver-experience/job-list/allocate-depot-dialog.component';
import { AllocateTruckDialogComponent } from './modules/driver-experience/job-list/allocate-truck-dialog.component';
import { SupplierJobsInboxItemMapComponent } from './modules/driver-experience/job-list/supplier-jobs-inbox-item-map.component';
import { SupplierJobScreenJobTasksComponent } from './components/job-screen/supplier/supplier-job-screen-job-tasks/supplier-job-screen-job-tasks.component';
import { JobScreenTaskTimesComponent } from './components/job-screen/common/job-screen-task-times/job-screen-task-times.component';
import { JobScreenSupplierScheduleComponent } from './components/job-screen/common/job-screen-supplier-schedule/job-screen-supplier-schedule.component';
import { DeploySupplierCardComponent } from './components/job-deployment/deploy-supplier-card.component';
import { TaskVehicleDetailsComponent } from './modules/driver-experience/job-list/task-vehicle-details.component';
import { What3wordsComponent } from './components/logos/what3words/what3words.component';
import { VmeExpenseValidationResultComponent } from './components/job-screen/vme/vme-additional-costs/vme-expense-validation-result/vme-expense-validation-result.component';
import { JobScreenLocationComponent } from './components/job-screen/common/job-screen-location/job-screen-location';
import { RouteItineraryComponent } from './components/route-recommendations/route-itinerary/route-itinerary.component';
import { RouteItineraryPopupComponent } from './components/route-recommendations/route-itinerary/popups/route-itinerary-popup/route-itinerary-popup.component';
import { JobScreenCarryOverComponent } from './components/job-screen/common/job-screen-carry-over/job-screen-carry-over.component';
import { JobScheduleCarryOverComponent } from './components/job-screen/common/job-screen-carry-over/job-schedule-carry-over.component';
import { CarryoverTaskInfoComponent } from './components/job-screen/common/job-screen-carry-over/carryover-task-info.component';
import { CarryOverAuthComponent } from './components/carry-over-auth/carry-over-auth.component';
import { MapControlV2Component } from './components/map-control-v2/map-control-v2.component';
import { RouteIconComponent } from './components/route-recommendations/route-itinerary/components/route-icon/route-icon.component';
import { CombineGrabDisabledJobDialogComponent } from './components/jobs-inbox/combine-grab-disabled-job-dialog/combine-grab-disabled-job-dialog.component';
import { QueueAutoDirectButtonComponent } from './components/auto-direct/queue-auto-direct-button.component';
import { TravelSchedulerComponent } from './components/travel-scheduler/travel-scheduler.component';
import { VerticalDotsContainerComponent } from './modules/driver-experience/job-list/vertical-dots-container.component';
import { ChangeAssigneeComponent } from './components/job-control/change-assignee/change-assignee.component';
import { ScheduleTaskComponent } from './components/travel-scheduler/schedule-task/schedule-task.component';
import { TravelSchedulerSummaryTaskComponent } from './components/travel-scheduler/travel-scheduler-summary-task/travel-scheduler-summary-task.component';
import { TurnstileComponent } from './user-controls/turnstile/turnstile.component';

const components = [
  CarryOverAuthComponent,
  OrgStructureComponent,
  InlineProfileComponent,
  MapControl,
  DirectionsMapDirective,
  TaskPolylineMapDirective,
  ContextMenuMapDirective,
  TaskControl,
  DisplayRouteComponent,
  SelectSupplierComponent,
  CardMenuComponent,
  CreateMovementDepartmentTeamComponent,
  StepIndicatorComponent,
  OrgStructureMainComponent,
  UserDetailsComponent,
  JobDetailsComponent,
  BoardingCheckListComponent,
  VmeJobsGridComponent,
  VmeJobsTasksComponent,
  CustomerJobsGridComponent,
  JobsTasksLiveComponent,
  JobsTasksGridComponent,
  ProgressBarComponent,
  NewDisputeComponent,
  VmeJobsWaitingApprovalComponent,
  DatetimePickerComponent,
  CustomersInvoicesGridComponent,
  SuppliersBatchesComponent,
  SuppliersInvoicesGridComponent,
  TransactionLinesGridComponent,
  SupplierInvoiceViewComponent,
  AgreementServicesGridComponent,
  RoutesRolesComponent,
  ApiVersionComponent,
  ManagePostcodesWeightComponent,
  ManagePremiumsComponent,
  SupplierAdhocInvoiceComponent,
  OrgTreeComponent,
  OrganisationSelectListComponent,
  JobDeploymentDetailsComponent,
  SupplierCardComponent,
  DeploySupplierCardComponent,
  DriverPlanComponent,
  HistoryTimelineComponent,
  NewSupplierFeedbackComponent,
  SupplierAvailabilityComponent,
  XeroSettingsComponent,
  SupplierAvailabilityCalendarComponent,
  CustomerTaggingComponent,
  TaggingTagsDetailsComponent,
  TaggingSelectSupplierComponent,
  TaggingSelectCustomerComponent,
  TaggingRequirementsDetailsComponent,
  SupplierJobsGridComponent,
  SupplierJobsCardComponent,
  AppFullCalendarComponent,
  AppWeeklyCalendarComponent,
  SupplierJobsInboxItemComponent,
  SupplierJobsInboxItemMapComponent,
  TasksMapComponent,
  OrderValidateComponent,
  OrderCompletedComponent,
  IncidentsGridComponent,
  IncidentsStatisticsComponent,
  IncidentsStacisticsItemComponent,
  VMEJobsFacetedFilteringComponent,
  EditTaskComponent,
  RescheduleTaskComponent,
  ECMatchDetailsComponent,
  ECMatchJobDetailsComponent,
  DashboardEngineiusKPIComponent,
  JobTimeWindowComponent,
  ManageTimeBandPremiumsComponent,
  DashboardEngineiusKPIsTopLevelComponent,
  DashboardEngineiusKPIGeneralComponent,
  DashboardEngineiusKPICommercialComponent,
  DashboardEngineiusKPIOperationsComponent,
  DashboardEngineiusKPIFinancialComponent,
  DashboardCustomerKPIVolumeComponent,
  DashboardCustomerKPITopLevelComponent,
  DashboardCustomerKPIServiceLevelsComponent,
  DashboardCustomerKPIUrgencyComponent,
  DashboardCustomerKPITimeWindowsComponent,
  DashboardCustomerKPIDisplayComponent,
  DashboardCustomerKPISummaryComponent,
  FacetedFilteringSavedSearchesComponent,
  KeyMetricComponent,
  OrganisationSelectorGridComponent,
  TaskSupplierScheduleStepComponent,
  EditTaskScheduleDialogComponent,
  AllocateDriverDialogComponent,
  AllocateJobDialogComponent,
  AcceptJobDialogComponent,
  SupplierScheduleDialogComponent,
  RouteHideReasonDialogComponent,
  DisplayRouteSimpleComponent,
  TaskSupplierScheduleTimelineComponent,
  OrganisationSelectorGridComponent,
  TaskSupplierSchedulePanelComponent,
  TaskSupplierScheduleWindowComponent,
  VehicleAddressComponent,
  SupplierSignupTypeComponent,
  ViewOdometerImageDialogComponent,
  OrderLimitsCalendarComponent,
  CustomerSitesComponent,
  CustomerSitesOpeningTimesComponent,
  CustomerSitesOpeningTimesRowComponent,
  JobScreenGalleryComponent,
  BankHolidayWarningComponent,
  MobileInformationsComponent,
  RescheduleTaskDialogComponent,
  TaskStaticMapComponent,
  CustomerSitesEditorComponent,
  AvailabilityHelpComponent,
  TaskTimeAndLocationContainerComponent,
  TaskVehicleDetailsComponent,
  TaskDividerComponent,
  HideJobDialogComponent,
  AllocateDepotDialogComponent,
  AllocateTruckDialogComponent,
  SupplierJobScreenJobTasksComponent,
  JobScreenLocationComponent,
  JobScreenTaskTimesComponent,
  JobScreenSupplierScheduleComponent,
  VmeExpenseValidationResultComponent,
  MapControlV2Component,
  TurnstileComponent,
];

/**
 * Shared Module (Components)
 * todo: this isn't just components it forwards the directives module and the AGM module.
 */
@NgModule({
  imports: [
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    JobAlertSettingsAdminModule,
    AlgoTravelPreferencesModule,
    ChecklistCategoryItemModule,
    TableModule,
    ToastModule,
    VirtualScrollerModule,
    AutoCompleteModule,
    AgmOverlays,
    OverlayPanelInputComponent,
    What3wordsComponent,
    RouteItineraryComponent,
    RouteItineraryPopupComponent,
    JobScreenCarryOverComponent,
    JobScheduleCarryOverComponent,
    CarryoverTaskInfoComponent,
    RouteIconComponent,
    CombineGrabDisabledJobDialogComponent,
    QueueAutoDirectButtonComponent,
    TravelSchedulerComponent,
    VerticalDotsContainerComponent,
    ChangeAssigneeComponent,
    ScheduleTaskComponent,
    TravelSchedulerSummaryTaskComponent,
  ],
  declarations: [...components],
  exports: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // todo: check, this might need tob e in other modules now
})
export class VMEComponentsModule {}
